<template>
    <div class="disk_container">
        <div class="top_img">
            <img src="../assets/img/ddr.png" alt />
        </div>
        <div class="tab_container">
            <ul :class="{fixed:isFixed}">
                <li v-for="(ele,index) in dataList" :key="index" @click="tabChange(index)">
                    <span :class="{active:ele.active}">{{ele.name}}</span>
                </li>
            </ul>
            <div :class="['content_wrap',{add_padding:isFixed}]" v-if="contentList">
                <div class="content">
                    <div class="des">
                        <div class="img">
                            <img :src="imgsrc" alt />
                        </div>
                        <div class="descontent">
                            <p>{{name}}</p>
                            <p>¥{{price}}</p>
                        </div>
                    </div>
                    <div class="type">
                        <p class="title">类型：</p>
                        <div class="list">
                            <div
                                v-for="(ele,index) in contentList"
                                :key="index"
                                :class="{active:ele.active}"
                                @click="changeType(ele,index)"
                            >{{ele.name}}</div>
                        </div>
                    </div>
                    <div class="type" v-if="versionList">
                        <p class="title">版本：</p>
                        <div class="list">
                            <div
                                v-for="(ele,index) in versionList"
                                :key="index"
                                :class="{active:ele.active}"
                                @click="changeVersion(ele,index)"
                            >{{ele.name}}</div>
                        </div>
                    </div>
                    <!-- <div class="type" v-if="sizeList">
                        <p class="title">容量：</p>
                        <div class="list">
                            <div
                                v-for="(ele,index) in sizeList"
                                :key="index"
                                :class="{active:ele.active}"
                                @click="changeSize(ele,index)"
                            >{{ele.name}}</div>
                        </div>
                    </div> -->
                    <div class="order_now" @click="appoint">立即预约</div>
                </div>
            </div>
            <div class="order_msg">
                <p>填写预约信息</p>
                <div class="select_wrap selected">上门维修</div>
                <div :class="['select_wrap',{selected:textList.city}]" @click="openSelectCity">
                    {{textList.city?textList.city:'请选择省市区'}}
                    <img src="../assets/img/bottom.png" alt />
                </div>
                <div :class="['select_wrap',{selected:textList.reserveTime}]" @click="openReserveTime">
                    {{textList.reserveTime?textList.reserveTime:'请选择预约时间'}}
                    <img
                        src="../assets/img/bottom.png"
                        alt
                    />
                </div>
                <div class="address">
                    <textarea placeholder="请输入详细地址" v-model="detailAddress"></textarea>
                </div>
                <div class="msg">
                    <input type="text" placeholder="请输入您的姓名" v-model="username" />
                </div>
                <div class="msg">
                    <input type="tel" placeholder="请输入您的手机号" v-model="phone_number" />
                </div>
                <div class="msg">
                    <input type="tel" placeholder="请输入图形验证码" v-model="img_code" />
                    <img :src="img_src" alt @click="changeImg" />
                </div>
                <div class="msg">
                    <input type="tel" placeholder="请输入短信验证码" v-model="sms_code"  maxlength="4"/>
                    <button
                        :class="{disabled:isbtndisabled}"
                        @click="!isbtndisabled && get_textreg()"
                        v-html="code_msg"
                    ></button>
                </div>
                <div class="order_immedate">
                    <button @click="!btnDisabled && orderNow()">立即下单</button>
                </div>
            </div>
        </div>
		<div class="detail_img">
			<img :src="detailSrc" alt="">
		</div>

        <div
            class="bottomDrawer"
            v-show="showDrawer"
            @click.prevent="showDrawer=false"
            @touchmove="stopDefault($event)"
        ></div>
        <div
            :class="['bottomDrawerContainer',{active:showDrawer}]"
            @touchmove="stopDefault($event)"
        >
            <div class="topButton">
                <p class="closeBtn" @click="closeDrawer(false)"></p>
                <p class="buttonTitle" v-show="temp_popType==1">请选择省市区</p>
                <p class="buttonTitle" v-show="temp_popType==2">请选择预约时间</p>
                <p class="completeBtn" @click="closeDrawer(true)">完成</p>
            </div>
            <div class="cityContainer" v-show="temp_popType==1">
                <div class="addMemory_panel">
                    <div class="addMemory_repairtype">
                        <mt-picker :slots="LocationSlots" @change="onValuesChange" valueKey="name"></mt-picker>
                    </div>
                </div>
            </div>
			<!-- 预约时间 -->
			<div class="reserverTimeContainer" v-show="temp_popType==2">
				<div class="addMemory_panel">
					<div class="addMemory_repairtype">
						<mt-picker
							:slots="reserverTimeSlots"
							@change="onTimeValuesChange"
							valueKey="date"
						></mt-picker>
					</div>
				</div>
			</div>
        </div>	

        <div class="modle_wrap_bg" v-show="orderSuccess"></div>

		<div class="loadingGif" v-show="dataJiazai">
			<img src="../assets/img/zhengzaijiazai.gif" alt="">
		</div>

		<div class="order_success" v-show="orderSuccess">
			<img src="../assets/img/weixin.png" alt="" v-if="!isweixin">
			<img src="../assets/img/xiaochengxu.png" alt="" v-else>
		</div>

        <tipDrawer :showthis.sync="showthis" :showtext="showtext"></tipDrawer>

    </div>
</template>
<script>
import tipDrawer from "../components/tipDrawer";
export default {
    components: {
        tipDrawer
    },
    data() {
        return {
			detailSrc:'',
			dataJiazai:false,
			orderSuccess:false,
			btnDisabled:false,
			isFixed:false,
			temp_popType:1,
            showthis: false,
            showtext: "",
            dataList: [
                {
                    name: "DDR3",
                    active: true,
                    children: [
                        {
                            name: "威刚(ADATA）DDR3  笔记本/台式机内存条",
                            img: require("../assets/img/ddr3.png"),
                            children: [
                                {
                                    name: "笔记本",
                                    active: true,
                                    children: [
                                        {
                                            name: "DDR3[1333频]",
                                            active: true,
                                            children: [
                                                {
                                                    name: "4GB",
                                                    active: true,
                                                    price: "1500.00"
                                                },
                                                {
                                                    name: "8GB",
                                                    active: false,
                                                    price: "1.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "DDR3[1600频]",
                                            active: false,
                                            children: [
                                                {
                                                    name: "22GB",
                                                    active: true,
                                                    price: "1200.00"
                                                },
                                                {
                                                    name: "11GB",
                                                    active: false,
                                                    price: "1.00"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    name: "台式机",
                                    active: false,
                                    children: [
                                        {
                                            name: "DDR3[1111频]",
                                            active: true,
                                            children: [
                                                {
                                                    name: "1GB",
                                                    active: true,
                                                    price: "111.00"
                                                },
                                                {
                                                    name: "2GB",
                                                    active: false,
                                                    price: "888.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "DDR3[2222频]",
                                            active: false,
                                            children: [
                                                {
                                                    name: "3GB",
                                                    active: true,
                                                    price: "999.00"
                                                },
                                                {
                                                    name: "7GB",
                                                    active: false,
                                                    price: "1234.00"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: "DDR4",
                    active: false,
                    children: [
                        {
                            name: "威刚(ADATA）DDR4  笔记本/台式机内存条",
                            img: require("../assets/img/ddr3.png"),
                            children: [
                                {
                                    name: "笔记本",
                                    active: true,
                                    children: [
                                        {
                                            name: "DDR3[4312频]",
                                            active: true,
                                            children: [
                                                {
                                                    name: "16GB",
                                                    active: true,
                                                    price: "4567.00"
                                                },
                                                {
                                                    name: "32GB",
                                                    active: false,
                                                    price: "8888.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "DDR4[3200频]",
                                            active: false,
                                            children: [
                                                {
                                                    name: "11GB",
                                                    active: true,
                                                    price: "999.00"
                                                },
                                                {
                                                    name: "12GB",
                                                    active: false,
                                                    price: "8899.00"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    name: "台式机",
                                    active: false,
                                    children: [
                                        {
                                            name: "DDR4[8765频]",
                                            active: true,
                                            children: [
                                                {
                                                    name: "9GB",
                                                    active: true,
                                                    price: "654.00"
                                                },
                                                {
                                                    name: "11GB",
                                                    active: false,
                                                    price: "765.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "DDR4[1256频]",
                                            active: false,
                                            children: [
                                                {
                                                    name: "11GB",
                                                    active: true,
                                                    price: "444.00"
                                                },
                                                {
                                                    name: "21GB",
                                                    active: false,
                                                    price: "666.00"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: "SSD",
                    active: false,
                    children: [
                        {
                            name: "威刚(ADATA）DDR4  笔记本/台式机固态硬盘",
                            img: require("../assets/img/ssd.png"),
                            children: [
                                {
                                    name: "笔记本",
                                    active: true,
                                    children: [
                                        {
                                            name: "SSD1",
                                            active: true,
                                            children: [
                                                {
                                                    name: "加装120G SSD",
                                                    active: true,
                                                    price: "1111.00"
                                                },
                                                {
                                                    name: "加装256G SSD",
                                                    active: false,
                                                    price: "2222.00"
                                                },
                                                {
                                                    name: "加装512G SSD",
                                                    active: false,
                                                    price: "333.00"
                                                },
                                                {
                                                    name: "系统恢复",
                                                    active: false,
                                                    price: "4444.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "SSD1",
                                            active: false,
                                            children: [
                                                {
                                                    name: "加装120G SSD",
                                                    active: true,
                                                    price: "1111.00"
                                                },
                                                {
                                                    name: "加装256G SSD",
                                                    active: false,
                                                    price: "2222.00"
                                                },
                                                {
                                                    name: "加装512G SSD",
                                                    active: false,
                                                    price: "333.00"
                                                },
                                                {
                                                    name: "系统恢复",
                                                    active: false,
                                                    price: "4444.00"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    name: "台式机",
                                    active: false,
                                    children: [
                                        {
                                            name: "DDR4[8765频]",
                                            active: true,
                                            children: [
                                                {
                                                    name: "9GB",
                                                    active: true,
                                                    price: "654.00"
                                                },
                                                {
                                                    name: "11GB",
                                                    active: false,
                                                    price: "765.00"
                                                }
                                            ]
                                        },
                                        {
                                            name: "DDR4[1256频]",
                                            active: false,
                                            children: [
                                                {
                                                    name: "11GB",
                                                    active: true,
                                                    price: "444.00"
                                                },
                                                {
                                                    name: "22GB",
                                                    active: false,
                                                    price: "666.00"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: "移动硬盘外壳",
                    active: false,
                    children: [
                        {
                            name: "威刚(ADATA）DDR4  笔记本/台式机固态硬盘",
                            img: require("../assets/img/keer.png"),
                            children: [
                                {
                                    name: "移动固态硬盘",
                                    active: true
                                }
                            ]
                        }
                    ]
                }
            ],
            contentList: null,
            versionList: null,
            sizeList: null,
			price: "",
			name:'',
            textList: {
                city: "",
                reserveTime: ""
            },
            detailAddress: "",
            username: "",
            phone_number: "",
            img_code: "",
            img_src: "",
            img_id: "",
            sms_id: "",
            sms_code: "",
            isbtndisabled: false,
            code_msg: "获取验证码",
            showDrawer: false,
            province_id: "",
            city_id: "",
            district_id: "",
            LocationSlots: [
                {
                    flex: 1,
                    values: [],
                    className: "slot1",
                    textAlign: "center",
                    defaultIndex: 0
                },
                {
                    flex: 1,
                    values: [],
                    className: "slot2",
                    textAlign: "center",
                    defaultIndex: 0
                },
                {
                    flex: 1,
                    values: [],
                    className: "slot3",
                    textAlign: "center",
                    defaultIndex: 0
                }
            ],
            picker: null,
            locations: null,
            reserverTimeSlots: [
                {
                    flex: 1,
                    values: [],
                    className: "slot4",
                    textAlign: "center"
                },
                {
                    flex: 1,
                    values: [],
                    className: "slot5",
                    textAlign: "center"
                }
            ],
            //   预约时间选择器
			timePicker: null,
			reserverTimeList:null,
			reserve_time:'',
			reserve_time2:'',
			rp_id:'',
			imgsrc:'',
            scrollTop: null,
        };
    },
    methods: {
        // 关闭模态框
        closeDrawer(bool) {
            if (bool) {
                if (this.temp_popType == 1) {
                    var result = this.picker.getValues();
                    this.textList.city =
                        result[0].name +
                        " / " +
                        result[1].name +
                        " / " +
                        result[2].name;
                    this.province_id = result[0].id;
                    this.city_id = result[1].id;
                    this.district_id = result[2].id;
                } else if (this.temp_popType == 2) {
                    var timeResult = this.timePicker.getValues();
                    this.textList.reserveTime =
                        timeResult[0].date +
                        "  " +
                        timeResult[1].start_time +
                        " ~ " +
                        timeResult[1].next_time;
                    this.reserve_time = timeResult[1].start_datetime;
                    this.reserve_time2 = timeResult[1].next_datetime;
                }
            }
            this.showDrawer = false;
        },
        // 阻止默认事件
        stopDefault(e) {
            e = e || window.event;
            if (e.stopPropagation) {
                //W3C阻止冒泡方法
                e.stopPropagation();
            } else {
                e.cancelBubble = true; //IE阻止冒泡方法
            }
            if (e && e.preventDefault) {
                e.preventDefault(); //阻止默认浏览器动作(W3C)
            } else {
                window.event.returnValue = false; //IE中阻止函数器默认动作的方式
            }
        },
        // 打开城市选择
        openSelectCity() {
            this.showDrawer = true;
            this.temp_popType = 1;
		},
		// 打开预约时间
		openReserveTime(){
			if(!this.city_id){
				this.showthis = true;
				this.showtext = '请选择省市区'
				return
			}
			this.getReserveTime();
			this.temp_popType=2;
			this.showDrawer=true
		},
        // 省市区变化
        onValuesChange(picker, values) {
            this.picker = picker;
            if (values[0] && values[1] && values[2]) {
                this.picker.setSlotValues(1, values[0].cities);
                this.picker.setSlotValues(2, values[1].districts);
            }
        },
        // 获取地址
        getLocations() {
			var that = this;
            this.locations = null;
            this.$axios
                .post(
                    "//mapi.hiweixiu.com/v2/regions/all",
                    this.$qs.stringify({
                        type: 2
                    })
                )
                .then(
                    res => {
                        if (res.data.code == 200) {
                            this.locations = res.data.data.provinces;
                            that.picker.setSlotValues(0, that.locations);
                            that.picker.setSlotValues(
                                1,
                                that.locations[0].cities
                            );
                            that.picker.setSlotValues(
                                2,
                                that.locations[0].cities[0].districts
                            );
                        } else {
                            this.showthis = true;
                            this.showtext = res.data.msg;
                        }
                    },
                    err => {
                        if (err.response.status == 401) {
                            this.showthis = true;
                            this.showtext = "请先登录";
                        } else if (err.response.status == 500) {
                            this.showthis = true;
                            this.showtext = "网络异常，请稍后再试";
                        }
                    }
                );
		},
        // 预约时间选择
        onTimeValuesChange(picker, values) {
            this.timePicker = picker;
            if (values[0] && values[1]) {
                this.timePicker.setSlotValues(1, values[0].periods);
            }
        },
        //   获取上门维修的预约时间
        getReserveTime() {
            this.$axios
                .post(
                   	"//mapi.hiweixiu.com/v2/reserve/normal-time",
                    this.$qs.stringify({
                        city: this.city_id,
                        district: this.district_id
                    })
                )
                .then(res => {
                    if (res.data.code == 200) {
                        res.data.data.forEach((ele, key) => {
                            ele.periods.forEach(item => {
                                item.date =
                                    item.week +
                                    ":" +
                                    item.start_time +
                                    "~" +
                                    item.next_time;
                            });
                        });
                        this.reserverTimeList = res.data.data;
                        this.timePicker.setSlotValues(0, this.reserverTimeList);
                        this.timePicker.setSlotValues(
                            1,
                            this.reserverTimeList[0].periods
                        );
                    } else {
						this.showthis = true;
						this.showtext = res.data.msg
                    }
                });
        },
        // 更换图形验证码
        changeImg() {
            var params = {
                img_id: this.img_id
            };
            this.$axios
                .post("//mapi.hiweixiu.com/v1/verify/img/code", this.$qs.stringify(params))
                .then(res => {
                    if (res.data.code == 200) {
                        this.img_src = res.data.data.data;
                        this.img_id = res.data.data.id;
                    }
                });
        },
        get_textreg() {
            this.isbtndisabled = true;
            this.loadtextmsg();
        },
        // 得到短信验证码
        loadtextmsg() {
            // this.showthis = true;
            // this.showtext = "获取短信验证码成功，请注意查收+假的";
            var params = {
                phone_number: parseInt(this.phone_number),
                sms_id: this.sms_id,
                img_code: parseInt(this.img_code),
                img_id: this.img_id
            };
            this.$axios
                .post("//mapi.hiweixiu.com/v2/verify/sms/code", this.$qs.stringify(params))
                .then(res => {
                    if (res.data.code == 200) {
                        this.showthis = true;
                        this.showtext = "验证码获取成功,请注意查收";
                        this.sms_id = res.data.data.id;
                        this.changecontent();
                    } else {
                        this.isdisabled = false;
                        this.showthis = true;
                        this.showtext = res.data.msg;
                        this.isbtndisabled = false;
                    }
                });
        },
        // 倒计时
        changecontent() {
            var time = 60;
            var timer = setInterval(() => {
                time--;
                this.code_msg = time + "后重新获取";
                // this.isbtndisabled = true;
                if (time  <= 0) {
                    clearInterval(timer);
                    this.readonly = false;
                    this.isbtndisabled = false;
                    this.code_msg = "获取验证码";
                }
            }, 1000);
        },
        dataChange() {
            this.contentList = null;
            this.versionList = null;
            this.sizeList = null;
            if (this.dataList) {
                this.contentList = this.dataList.find(ele => {
					this.detailSrc = ele.src;
                    return ele.active;
                }).children;
            }
            if (this.contentList && this.contentList) {
                this.versionList = this.contentList.find(ele => {
                    return ele.active;
                }).children.find(ele => {
					this.name = ele.name;
					this.imgsrc = ele.src;
                    return ele.active;
                }).children;
            }
            if (this.versionList) {
                this.versionList.forEach(element => {
                    if (element.active) {
						this.price = element.price;
						this.rp_id = element.rp_id;
                    }
                });
			}
			this.dataJiazai = false;
			// console.log("this.dataList");
			// console.log(this.dataList);
			// console.log("this.contentList");
			// console.log(this.contentList);
			// console.log("this.versionList");
			// console.log(this.versionList);
        },
        tabChange(index) {
            this.dataList.forEach((ele, key) => {
                ele.active = false;
                if (index == key) {
                    ele.active = true;
                }
			});
			this.dataJiazai = true;
			this.dataChange();
			$('html,body').animate({scrollTop:$('.tab_container').offset().top},200)
        },
        changeType(ele, index) {
            this.contentList.forEach((item, key) => {
                item.active = false;
                if (key == index) {
                    item.active = true;
                }
            });
            this.dataChange();
        },
        changeVersion(ele, index) {
            this.versionList.forEach((item, key) => {
                item.active = false;
                if (key == index) {
                    item.active = true;
                }
            });
            this.dataChange();
        },
        changeSize(ele, index) {
            this.sizeList.forEach((item, key) => {
                item.active = false;
                if (key == index) {
                    item.active = true;
                }
            });
            this.dataChange();
		},
		// 滚动时固定定位
		fixDom(){
			if($(document).scrollTop()>=$('.tab_container').offset().top){
				this.isFixed = true;
			}else{
				this.isFixed = false;
			}
		},
		// 立即预约
		appoint(){
			$('html,body').animate({scrollTop:$('.order_msg').offset().top},200)
		},
		// 通过递归添加active
		addActive(ele){
			if(ele.children){
				ele.children.forEach((item,key)=>{
					item.active = false;
					if(key == 0){
						item.active = true;
					}
					this.addActive(item);
				})
			}
		},
		getData(){
			this.$axios.get('//mapi.hiweixiu.com/v3/promotion/h5_201906/mould/ssd?brand_id=72&fault_id=426').then(res=>{
				if(res.data.code == 200){
					res.data.data.forEach((ele,index)=>{
						ele.active = false;
						if(index == 0){
							ele.active = true;
						}
						this.addActive(ele);
					})
					this.dataList = res.data.data;
					// console.log("res+++")
					// console.log(this.dataList);
        			this.dataChange();
				}
			})
		},
        // 获取ref参数
        getParam(paramName) {
            var paramValue = "",
                isFound = !1;
            if (
                location.search.indexOf("?") == 0 &&
                location.search.indexOf("=") > 1
            ) {
                var arrSource = unescape(location.search)
                        .substring(1, location.search.length)
                        .split("&"),
                    i = 0;
                while (i < arrSource.length && !isFound)
                    arrSource[i].indexOf("=") > 0 &&
                        arrSource[i].split("=")[0].toLowerCase() ==
                            paramName.toLowerCase() &&
                        ((paramValue = arrSource[i].split("=")[1]),
                        (isFound = !0)),
                        i++;
            }
            return paramValue == "" && (paramValue = null), paramValue;
		},
		orderNow(){
			this.btnDisabled = true;
			var params = {
				username: this.username,
				phone_number:this.phone_number,
				reserve_time:this.reserve_time,
				reserve_time2:this.reserve_time2,
				province:this.province_id,
				city:this.city_id,
				district:this.district_id,
				address:this.detailAddress,
				rp_id:this.rp_id,
				is_warrantable:0,
				category:1,
				remark: '',
				imei: '',
				coupon_code: '',
				weixiucenter_id: '',
				sms_code: this.sms_code,
				img_id: this.img_id,
				img_code: this.img_code,
			}
            var url = this.getParam("ref")
                ? "//mapi.hiweixiu.com/v3/promotion/h5_201906/orders/create?ref=" + this.getParam("ref")
				: "//mapi.hiweixiu.com/v3/promotion/h5_201906/orders/create";
			this.$axios.post(url,this.$qs.stringify(params)).then(res=>{
				if(res.data.code == 200){
					this.orderSuccess = true;
				}else{
					this.showthis = true;
					this.showtext = res.data.msg;
				}
				this.btnDisabled = false;
			})
		}
	},
    computed: {
        isweixin() {
            const ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return true;
            } else {
                return false;
            }
        }
    },
	watch:{
		orderSuccess(){
			if(this.orderSuccess){
                this.scrollTop = document.scrollingElement.scrollTop;
                document.body.classList.add("modal-open");
                document.body.style.top = -this.scrollTop + "px";
			}else{
                document.body.classList.remove("modal-open");
                document.scrollingElement.scrollTop = this.scrollTop;
			}
		},
		rp_id(){
			// console.log("this.rp_id+++");
			// console.log(this.rp_id);
		}
	},
    created() {
		console.log(11111)
		this.dataJiazai = true;
		this.changeImg();
		this.getLocations();
		this.getData();
		$(document).on('scroll',this.fixDom);
    }
};
</script>
<style lang="scss" scoped>
.disk_container {
    .top_img {
        font-size: 0;
        width: 100%;
        img {
            width: 100%;
        }
    }
    .tab_container {
        width: 100%;
        background: #3d4045;
        ul {
            display: flex;
            justify-content: space-evenly;
            background: #232323;
			width: 100%;
            li {
                display: flex;
                align-items: center;
                height: 45px;
                padding: 5px 0;
                span {
                    display: block;
                    color: #fff;
                    font-size: 16px;
                    line-height: 30px;
                    border-bottom: 2px solid transparent;
                    transition: all 0.2s;
                }
                span.active {
                    border-bottom: 2px solid #fff;
                }
            }
        }
		ul.fixed{
			position: fixed;
			z-index: 100;
			top: 0;
		}
        .content_wrap {
            padding: 16px;
			padding-bottom: 0;
            .content {
                background: #fff;
                box-shadow: 0px 0px 29px 0px rgba(4, 4, 4, 0.4);
                border-radius: 5px;
                padding: 16px;
                .order_now {
                    width: 100%;
                    line-height: 45px;
                    text-align: center;
                    font-size: 18px;
                    color: #fff;
                    background: #ff7a00;
                    letter-spacing: 2px;
                    margin-top: 16px;
                    border-radius: 5px;
                }
                .des {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .img {
                        width: 125px;
                        height: 125px;
                        margin-right: 16px;
                        img {
                            width: 125px;
                            height: 125px;
                        }
                    }
                    .descontent {
                        p:first-child {
                            font-size: 16px;
                            font-weight: bold;
                            // color: #fff;
                        }
                        p:last-child {
                            margin-top: 16px;
                            font-size: 20px;
                            font-weight: bold;
                            color: #ff7a00;
                        }
                    }
                }
                .type {
                    margin-top: 16px;
                    .title {
                        color: #000;
                        font-size: 14px;
                    }
                    .list {
                        display: flex;
                        flex-wrap: wrap;
                        div {
                            border: 1px solid #e7e7e7;
                            color: #000;
                            font-size: 16px;
                            padding: 9px 13px;
                            margin-right: 12px;
                            margin-top: 12px;
                            border-radius: 5px;
                        }
                        div.active {
                            border: 1px solid #ff7a00;
                            color: #ff7a00;
                        }
                    }
                }
            }
        }
		.add_padding{
			padding-top: 61px;
		}
        .order_msg {
            margin-top: 16px;
            padding: 16px;
            padding-top: 0;
            p {
                font-size: 18px;
                color: #fff;
                letter-spacing: 2px;
                text-align: center;
            }
            .select_wrap {
                position: relative;
                width: 100%;
                padding: 12px 16px;
                font-size: 16px;
                color: #ababab;
                background: #fff;
                border-radius: 5px;
                margin-top: 16px;
                img {
                    position: absolute;
                    right: 16px;
                    top: 20px;
                    width: 16px;
                }
            }
            .select_wrap.selected {
                color: #000;
            }
            .address {
                width: 100%;
                margin-top: 16px;
                textarea {
                    width: 100%;
                    resize: none;
                    font-size: 16px;
                    color: #000;
                    border-radius: 5px;
                    padding: 12px 16px;
                }
            }
            .msg {
                width: 100%;
                margin-top: 16px;
                position: relative;
                input {
                    display: block;
                    width: 100%;
                    padding: 12px 16px;
                    border-radius: 5px;
                    font-size: 16px;
                }
                img {
                    position: absolute;
                    right: 0;
                    top: 0;
                    border-radius: 5px;
                    width: 125px;
                    height: 45px;
                }
                button {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 125px;
                    padding: 12px;
                    color: #fff;
                    font-size: 16px;
                    text-align: center;
                    border-radius: 5px;
                    background: #ff7a00;
                }
                .disabled {
                    background-color: transparent;
                    color: #ccc !important;
                }
            }
            .order_immedate {
                width: 100%;
                margin-top: 16px;
                button {
                    width: 100%;
                    font-size: 16px;
                    padding: 12px 16px;
                    background: #ff7a00;
                    color: #fff;
                    letter-spacing: 2px;
                    text-align: center;
                    border-radius: 5px;
                }
            }
        }
    }
	.detail_img{
		width: 100%;
		font-size: 0;
		img{
			width: 100%;
			font-size: 0;
		}
	}
    .bottomDrawer {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
    .bottomDrawerContainer {
        // height: 200px;
        width: 100%;
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 11;
        transform: translateY(100%);
        transition: transform 0.3s;
        border-radius: 10px 10px 0px 0px;
        padding: 0px 16px 0;
        .topButton {
            padding: 14px 0;
            width: 100%;
            display: flex;
            flex-flow: row;
            justify-content: space-between;
            border-bottom: 1px solid #e5e5e5;
            .closeBtn {
                width: 16px;
                height: 20px;
                background: url(../assets/img/closeDrawer.png) center
                    no-repeat;
                background-size: 14px;
            }
            .buttonTitle {
                font-size: 16px;
                color: #363636;
            }
            .completeBtn {
                font-size: 14px;
                color: #ff5000;
            }
        }
        .cityContainer {
            .addMemory_panel {
                margin: 0;
                padding: 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
                padding: 0 23px;
                .addMemory_repairtype {
                    box-sizing: border-box;
                    justify-content: space-between;
                    font-size: 15px;
                    width: 100%;
                    border-top: 1px solid rgb(229, 229, 229);
                    padding: 12px 16px 0;
                }
            }
        }
    }
    .bottomDrawerContainer.active {
        transform: translateY(0%);
    }
    .modle_wrap_bg {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
    }
	.loadingGif{
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		img{
			width: 50px;
		}
	}
	.order_success{
		width: 260px;
		position: fixed;
		top: 20%;
		left: 50%;
		transform: translateX(-50%);
		img{
			width: 260px;
			font-size: 0;
		}
	}
}
</style>
